module.exports = __webpack_public_path__ + "fonts/d8bd40fc-2c9a-4086-8784-aa10c7143886.5e10714e.eot";